import { render, staticRenderFns } from "./Adm.vue?vue&type=template&id=2030c806"
import script from "./Adm.vue?vue&type=script&lang=js"
export * from "./Adm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports